export default __webpack_public_path__ + "static/media/audi.7432b95d.png";